import { useTheme } from '@mui/material/styles';
import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

const UserProfileLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={360}
      backgroundColor={theme.palette.action.hover}
      foregroundColor={theme.palette.action.selected}
    >
      <circle cx="100" cy="132" r="100" />
      <circle cx="12" cy="260" r="12" />
      <circle cx="12" cy="300" r="12" />
      <circle cx="12" cy="340" r="12" />
      <rect x="48" y="250" rx="6" ry="6" width="220" height="18" />
      <rect x="48" y="290" rx="6" ry="6" width="220" height="18" />
      <rect x="48" y="328" rx="6" ry="6" width="220" height="18" />
    </ContentLoader>
  );
};

export default UserProfileLoader;
